import { create } from "zustand";

type SettingsMenuStore = {
  showSettingsMenu: boolean;
  page: string;
  toggleSettings: () => void;
};

export const useSettingsMenuStore = create<SettingsMenuStore>((set) => ({
  showSettingsMenu: false,
  page: "Manage abbreviations",
  toggleSettings: () => {
    set(({ showSettingsMenu }) => ({ showSettingsMenu: !showSettingsMenu }));
  },
}));

if (import.meta.hot) {
  import.meta.hot.accept((newModule) => {
    if (newModule) {
      newModule.useSettingsMenuStore.setState(useSettingsMenuStore.getState());
    }
  });
}
